export default __webpack_public_path__ + "static/Fly10-59bc5359f55c430dade4de4cb1c93d2d.mp3";